const AGENDA_STATE = [{
    agendamentos: [{}],
    // retornos: 0
}]

export default function agendaReducer(state = AGENDA_STATE, action) {
    switch (action.type) {
        case 'SET_AGENDAMENTOS':
            return [{ agendamentos: [...state[0].agendamentos, { dataInicio: action.payload.start, dataFim: action.payload.end, agenda: action.payload.data, retornos: action.payload.retornos }], }];
        case 'CLEAR_AGENDAMENTOS':
            return [{ agendamentos: [...state[0].agendamentos.filter(a => a.dataInicio !== action.payload.start && a.dataFim !== action.payload.end)] }];
        case 'REMOVE_ALL':
            return [{agendamentos:[]}]
        default:
            return state;
    }
}